export const PREVENT_SUBMIT = 'preventSubmit'
export const ALLOW_SUBMIT = 'allowSubmit'

/* form */
export const UPDATE_FORM_PERMALINK = 'updateFormPermalink'
export const UPDATE_FORM_FIELD = 'updateFormField'
export const REMOVE_FORM_FIELD = 'removeFormField'
export const ADD_FORM_BLOCK = 'addFormBlock'
export const DELETE_FORM_BLOCK = 'deleteFormBlock'
export const DUPLICATE_FORM_BLOCK = 'duplicateFormBlock'
export const DUPLICATE_BLOCK_FORM_FIELDS = 'duplicateBlockFormFields'
export const ADD_REPEATERS = 'duplicateBlockRepeaters'
export const REORDER_FORM_BLOCKS = 'reorderFormBlocks'
export const UPDATE_FORM_LOADING = 'updateFormLoading'
export const SET_FORM_ERRORS = 'setFormErrors'
export const SET_SERVER_VALID = 'setServerValid'
export const CLEAR_FORM_ERRORS = 'clearFormErrors'
export const UPDATE_FORM_SAVE_TYPE = 'updateFormSaveType'
export const REPLACE_FORM_FIELDS = 'replaceFormField'
export const ADD_FORM_FIELDS = 'addFormField'
export const EMPTY_FORM_FIELDS = 'emptyFormField'

export const SET_EDITED_ITEM = 'setEditedItem'
export const RESET_EDITED_ITEM = 'resetEditedItem'

/* Modal forms */
export const EMPTY_MODAL_FIELDS = 'emptyModalField'
export const UPDATE_MODAL_FIELD = 'updateModalField'
export const REMOVE_MODAL_FIELD = 'removeModalField'
export const REPLACE_MODAL_FIELDS = 'replaceModalField'

/* Tags */
export const SET_TAGGABLE_ITEMS = 'setTaggableItems'
export const ADD_TAGGABLE_ITEM = 'addTaggableItem'

export default {
  SET_EDITED_ITEM,
  RESET_EDITED_ITEM,
  SET_SERVER_VALID,

  PREVENT_SUBMIT,
  ALLOW_SUBMIT,
  UPDATE_FORM_PERMALINK,
  UPDATE_FORM_FIELD,
  REMOVE_FORM_FIELD,
  ADD_FORM_BLOCK,
  DELETE_FORM_BLOCK,
  DUPLICATE_FORM_BLOCK,
  DUPLICATE_BLOCK_FORM_FIELDS,
  ADD_REPEATERS,
  REORDER_FORM_BLOCKS,
  UPDATE_FORM_LOADING,
  SET_FORM_ERRORS,
  CLEAR_FORM_ERRORS,
  UPDATE_FORM_SAVE_TYPE,
  REPLACE_FORM_FIELDS,
  ADD_FORM_FIELDS,
  EMPTY_FORM_FIELDS,
  EMPTY_MODAL_FIELDS,
  UPDATE_MODAL_FIELD,
  REMOVE_MODAL_FIELD,
  REPLACE_MODAL_FIELDS,
  SET_TAGGABLE_ITEMS,
  ADD_TAGGABLE_ITEM
}
